import type { BlogPost, BlogPostSummary } from "@/lib/blog";
import { buildBlogArticleJsonLd } from "@/lib/blog-seo";

export function BlogArticleJsonLd({ post }: { post: BlogPost | BlogPostSummary }) {
  const jsonLd = buildBlogArticleJsonLd(post);

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
    />
  );
}
